import { render } from "./EcosystemReport.vue?vue&type=template&id=340eb668&scoped=true"
import script from "./EcosystemReport.vue?vue&type=script&lang=js"
export * from "./EcosystemReport.vue?vue&type=script&lang=js"

import "./EcosystemReport.vue?vue&type=style&index=0&id=340eb668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340eb668"]])

export default __exports__